// extracted by mini-css-extract-plugin
export var border = "_m-8";
export var brand = "_m-t";
export var button = "_m-l";
export var center = "_m-a";
export var centered = "_m-6";
export var closeButton = "_m-c";
export var disabledWrapper = "_m-m";
export var error = "_m-p";
export var extraLarge = "_m-4";
export var extraSmall = "_m-1";
export var fill = "_m-i";
export var footer = "_m-h";
export var footerAction = "_m-j";
export var footerButtons = "_m-k";
export var header = "_m-7";
export var headerWithClose = "_m-d";
export var icon = "_m-o";
export var info = "_m-s";
export var inline = "_m-9";
export var large = "_m-3";
export var main = "_m-e";
export var modal = "_m-0";
export var nearFull = "_m-5";
export var neutral = "_m-u";
export var noPadding = "_m-g";
export var none = "_m-v";
export var scrollable = "_m-f";
export var small = "_m-2";
export var success = "_m-r";
export var tight = "_m-n";
export var titleIcon = "_m-b";
export var warn = "_m-q";